module.exports = __webpack_public_path__ + "img/contact-hero-m.67c1f8f3.jpg";